import React, { forwardRef } from 'react';
import { Help as Nav4Help } from '@atlaskit/navigation-system';
import type { HelpProps, BaseIconButtonProps } from '@atlaskit/atlassian-navigation';

// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
export const Help: React.ForwardRefExoticComponent<
	BaseIconButtonProps & {
		badge?: React.ComponentType<{}>;
	} & React.RefAttributes<HTMLButtonElement>
> = forwardRef<HTMLButtonElement, HelpProps>((props, ref) => {
	const { badge, onClick, isSelected, label } = props;
	return (
		<Nav4Help badge={badge} label={label} onClick={onClick} isSelected={isSelected} ref={ref} />
	);
});
